export default __webpack_public_path__ + "static/media/brand-9.74cc9816.png";